module.exports = __webpack_public_path__ + "img/shoes_img@2x.bcf323ee.png";